import { EducationalInfo } from './educationalInfo';
import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EducationalInfoService {

  constructor(private http: HttpClient) { }

  getEducationInfo(){
    return this.http.get<any>(`${environment.apiUrl}/v1/qualifications`)
  }

  getEducationInfomation(){
    return this.http.get<any>(`${environment.apiUrl}/v1/qualifications`)
  }

  getEducationalTypes(){
    return this.http.get(`${environment.apiUrl}/v1/education-type`);
  }

  createEducationInfo(payload){
    return this.http.post<any>(`${environment.apiUrl}/v1/qualifications`,  payload)
  }

  updateEducationInfo(payload){
    return this.http.put<any>(`${environment.apiUrl}/v1/qualifications`,  payload)
  }

  deleteEducationInfo(id){
    return this.http.delete<any>(`${environment.apiUrl}/v1/qualifications/`+id+``)
  }
}
